import React, { useState, useEffect, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import withName from "../../hoc/withName";
import { Formik } from "formik";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { RestAPI } from "@aws-amplify/api-rest";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import * as constants from "../../utils/BillingUtils";
import LoadingDialog from "../Utils/LoadingDialog";
import SelfHelp from "../Utils/SelfHelp";
import DatosFact from "./DatosFact";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
import ButtonPrime from "../PrimeComponents/ButtonPrime";

const BillingPolicyAndTerms = ({dataSource}) => {
    const {t, i18n} = useTranslation();
    const selfHelpDescarga = [{
        tab: 1, header: { text: t("selfHelp.instructions") }, params:[]
    }];

    const serviceLevels = [
        {"label":t("billing.serviceLevels.0"), "id":constants.SERVICE_DROPCONTROL_FREE},
        {"label":t("billing.serviceLevels.1"), "id":constants.SERVICE_DROPCONTROL_LITE},
        {"label":t("billing.serviceLevels.2"), "id":constants.SERVICE_DROPCONTROL_DROPCONTROL},
        {"label":t("billing.serviceLevels.3"), "id":constants.SERVICE_DROPCONTROL_PREMIUM},
    ];
    const names = useMemo(() => [
        t("general.type"),
        t("billing.policyPage.nodesPlan"),
        t("billing.policyPage.monthValue"),
        t("billing.totalPeriod")
    ], [t]);
    const [billingInfoFarm, setBillingInfoFarm] = useState(null);
    const [countries, setCountries] = useState(null);
    const formatFarmInfo = (farmInfo, service) => {
        let nodes = farmInfo.nodos?.filter(nd => nd.contrato != null);
        const dcService = farmInfo?.lista?.precios?.filter(s => s.servicio_id === constants.SERVICE_DROPCONTROL)[0];
        let expertCount = 0;
        nodes = nodes.map(nd => {
            if(nd.contrato === "EXP-C1" || nd.contrato === "EXP-M1" || nd.contrato === "EXP-X1" || nd.contrato === "EXP-V1") {
                expertCount = expertCount+1;
            }
            const valor = dcService?.config?.[service]?.[nd.contrato];
            return {...nd, value:valor};
        });
        const cliAdditionalUser = farmInfo?.ser_cli?.find(s => s.servicio_id === constants.SERVICE_ADDITIONAL_USER);
        if (cliAdditionalUser?.config?.billedIn === dataSource.campo_id) {
            farmInfo.es_cliente=true;
        }else{
            farmInfo.es_cliente=false;
        }
        const discount= farmInfo?.lista.config_descuentos?.find(dcto => expertCount >= dcto.rangeMin && expertCount <= (dcto.rangeMax ?? Number.MAX_SAFE_INTEGER));
        const priceList = {...farmInfo?.lista, descuento:discount??{}};
        nodes = nodes.map(nd => {
            return {...nd, value:nd.value- ((nd.value*(priceList?.descuento?.discount??0)/100)).toFixed(2)};
        });
        setBillingInfoFarm(farmInfo);
        setNodes(nodes);
        setPriceList(priceList);
        formikRef.current && formikRef.current.setFieldValue("servicio_id",service);
        setIsLoading(false);
    };
    useEffect(() => {
        if(gridRef?.current) gridRef.current.refresh();
    },[t]);

    useEffect(() => {
        if(dataSource?.campo_id && billingInfoFarm == null){
            RestAPI.get("apiAdminDropControl","/billing/agreements",
                {queryStringParameters: {"farmId":dataSource.campo_id}}).then(async (response) => {
                const farmInfo = response?.[0]?.result?.farmInfo?.[0];
                if(farmInfo){
                    formikRef.current && formikRef.current.setFieldValue("datos_fact",farmInfo?.datos_fact);
                    const actualPlan = farmInfo?.ser_campo?.[0]?.config?.SERVICE;
                    setCountries(response?.[0]?.result?.countries);
                    formatFarmInfo(farmInfo, actualPlan);
                }
                setIsLoading(false);
            })
                .catch((error) => {
                    console.log(error);
                });
        }
    },[dataSource,billingInfoFarm]);

    const formikRef = useRef(null);
    const gridRef = useRef(null);
    const [nodes,setNodes] = useState([]);
    const [isLoading,setIsLoading] = useState(true);
    const [priceList,setPriceList] = useState(null);
    const [validate,setValidate] = useState(null);
    const reload = () => {
        setInterval(() => {
            window?.location?.reload();
        }, 5000);
    };
    const valueNodeTemplate = (rowData) => {
        if(rowData.value){
            return `${rowData.value} USD`;
        }
    };
    const valueNodeTotalTemplate = (rowData, billingInfo) => {
        if(rowData.value){
            switch (billingInfo?.periodo) {
                case 2:
                    return `${(rowData.value*3).toFixed(2)} USD`;
                case 3:
                    return `${(rowData.value*12).toFixed(2)} USD`;
                case 4:
                    return `${(rowData.value*6).toFixed(2)} USD`;
                default:
                    return t("billing.policyPage.periods.null");
            }
        }
    };

    useEffect(() => {
        if(formikRef.current && validate){
            formikRef.current.validateForm();
            setValidate(false);
        }
    }, [validate]);
    return (
        <div className="row-container">
            {isLoading?<LoadingDialog />:null}
            <div className="row">
                <div className="col-sm-12 col-lg-12">
                    <div id="cardRaw" className="card">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col col-sm-2 col-md-3 col-lg-3'>
                                    {false && selfHelpDescarga &&
                                        <SelfHelp t={t} lng={i18n.language} params={selfHelpDescarga} fertiTable />}
                                </div>
                                <div className='col col-sm-10 col-md-8 col-lg-6 text-center'>
                                    <h5 className="card-title"><span>{t("billing.policyPage.title")}</span></h5>
                                </div>
                            </div>
                            <div className='linea-titulo' />
                        </div>
                    </div>
                </div>
                <Formik innerRef={formikRef}
                    initialValues={{
                        "datos_fact":{"datos_fact_id":0},
                        "servicio_id":billingInfoFarm?.ser_campo?.[0]?.config?.SERVICE
                    }}
                    validate={(data) => {
                        const errors = {};
                        if(!data?.datos_fact?.nombre){
                            errors.datos_fact_nombre = "Required";
                        }
                        if(!data?.datos_fact?.direccion){
                            errors.datos_fact_direccion = "Required";
                        }
                        if(!data?.datos_fact?.ciudad){
                            errors.datos_fact_ciudad = "Required";
                        }
                        if(!data?.datos_fact?.tipo_pais_id){
                            errors.datos_fact_tipo_pais_id = "Required";
                        }
                        const requiredVat = countries?.find(c => c?.tipo_pais_id === data?.datos_fact?.tipo_pais_id)?.required_vat;
                        if(requiredVat && !data?.datos_fact?.vat_id){
                            errors.datos_fact_vat_id = "Required";
                        }
                        return errors;
                    }}
                    onSubmit={async (formData) => {
                        setIsLoading(true);
                        formData.period = t("billing.policyPage.periods."+billingInfoFarm?.periodo);
                        formData.lista = priceList;
                        formData.billingInfo = billingInfoFarm;
                        formData.nodes = nodes;
                        formData.datos_fact.pais = countries?.find(c => c?.tipo_pais_id === formData?.datos_fact?.tipo_pais_id)?.descripcion;

                        await RestAPI.post("apiAdminDropControl", "/billing/agreements", {body: formData}).then(async (response) => {
                            setIsLoading(false);
                            toast.success(t("billing.policyPage.successTyc"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                            reload();
                        })
                            .catch((error) => {
                                setIsLoading(false);
                                if(error?.response?.data === "MISSING_FACT_DATA"){
                                    toast.error(t("billing.errorMissingData"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                }
                                else if(error?.response?.data === "MISSING_VAT"){
                                    toast.error(t("billing.errorMissingVat"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                }
                                else if(error?.response?.data === "NO_AUTH"){
                                    toast.error(t("billing.errorMissingAuth"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                }
                                else if(error?.response?.data === "NO_CLIENT"){
                                    toast.error(t("billing.errorNoClient"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                }else{
                                    toast.error(t("billing.policyPage.errorTyc"), { position: toast.POSITION.TOP_RIGHT, autoClose: 5000 });
                                }
                                console.log(error);
                            });
                    }}
                >
                    {({values,setFieldValue, handleSubmit, errors}) => (
                        <>
                            <div className="col-xl-5 col-lg-12 col-sm-12">
                                <DatosFact validate={validate} setValidate={setValidate} errors={errors} farmInfo={billingInfoFarm} countries={countries} values={values} setFieldValue={setFieldValue} />
                            </div>
                            <div className="col-xl-7 col-lg-12 col-sm-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row linea-formulario">
                                            <div className="col-xl-2 col-lg-12 col-sm-12">
                                                <label className="boldie">{t("billing.policyPage.service")}</label>
                                            </div>
                                            <div className="col-xl-5 col-lg-12 col-sm-12 text-left">
                                                <label>{serviceLevels.find(m => m.id ===  (billingInfoFarm?.ser_campo?.find(s => s.servicio_id === constants.SERVICE_DROPCONTROL))?.config?.SERVICE)?.label}</label>
                                            </div>
                                            <div className="col-xl-3 col-lg-12 col-sm-12">
                                                <label className="boldie">{t("billing.policyPage.period")}</label>
                                            </div>
                                            <div className="col-xl-2 col-lg-12 col-sm-12">
                                                <label>{t("billing.policyPage.periods."+billingInfoFarm?.periodo)}</label>
                                            </div>
                                        </div>

                                        <div className="row linea-formulario">
                                            <div className="col-xl-4 col-lg-12 col-sm-12">
                                                <label className="boldie">{t("billing.policyPage.maxUser")}</label>
                                            </div>
                                            <div className="col-xl-3 col-lg-12 col-sm-12">
                                                <label>{priceList?.descuento?.includedUser}</label>
                                            </div>
                                            <div className="col-xl-3 col-lg-12 col-sm-12">
                                                <label className="boldie text-left">{t("billing.policyPage.valueUser")}</label>
                                            </div>
                                            <div className="col-xl-2 col-lg-12 col-sm-125">
                                                <label>{`${(priceList?.precios.find(s => s.servicio_id === constants.SERVICE_ADDITIONAL_USER)?.config?.[billingInfoFarm.es_cliente?"clientUser":"farmUser"])-(((priceList?.precios.find(s => s.servicio_id === constants.SERVICE_ADDITIONAL_USER)?.config?.[billingInfoFarm.es_cliente?"clientUser":"farmUser"])*priceList?.descuento?.discount??0))/100} USD`}</label>
                                            </div>
                                        </div>
                                        <div className="row linea-formulario">
                                            <div className="col-xl-4 col-lg-12 col-sm-12">
                                                <label className="boldie">{t("billing.policyPage.maxApi")}</label>
                                            </div>
                                            <div className="col-xl-3 col-lg-12 col-sm-12">
                                                <label>{priceList?.descuento?.includedAPI}</label>
                                            </div>
                                            <div className="col-xl-3 col-lg-12 col-sm-12">
                                                <label className="boldie text-left">{t("billing.policyPage.valueApi")}</label>
                                            </div>
                                            <div className="col-xl-2 col-lg-12 col-sm-12">
                                                <label>{`${(priceList?.precios.find(s => s.servicio_id === constants.SERVICE_ADDITIONAL_API)?.config?.[billingInfoFarm.es_cliente?"clientAPI":"farmAPI"])-(((priceList?.precios.find(s => s.servicio_id === constants.SERVICE_ADDITIONAL_API)?.config?.[billingInfoFarm.es_cliente?"clientAPI":"farmAPI"])*priceList?.descuento?.discount??0))/100} USD`}</label>
                                            </div>
                                        </div>


                                        <div className="row linea-formulario">
                                            <div className="col-xl-12 col-lg-12 col-sm-12">
                                                <label className="boldie">{t("farms.nodesTable.title")}</label>
                                            </div>
                                            <div className="col-xl-12 col-lg-12 col-sm-12">
                                                <DataTablePrime
                                                    t={t}
                                                    dataKey="nodo_id"
                                                    items={nodes}
                                                    scrollable
                                                    scrollHeight="500px"
                                                    paginator rows={10} rowsPerPageOptions={[10, 25, 50]}
                                                    size="small"
                                                    globalFilterFields={["razon_social", "nombre", "n_cliente_id"]}
                                                    fields={[
                                                        {field:"nombre",header:names[0], bodyStyle:{textAlign:"center"}},
                                                        {field:"contrato",header:names[1], bodyStyle:{textAlign:"center"}},
                                                        {field:"value",header:names[2], body:valueNodeTemplate, bodyStyle:{textAlign:"center"}},
                                                        {field:"total_periodo",header:names[3], body:(e) => valueNodeTotalTemplate(e, billingInfoFarm),  bodyStyle:{textAlign:"center"}},
                                                    ]}
                                                />
                                            </div>
                                        </div>
                                        <div className="row linea-formulario">
                                            <div className="col-12 text-sm-center mtem-05">
                                                <ButtonPrime label={t("billing.policyPage.accept")} onClick={handleSubmit} raised />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default withName(BillingPolicyAndTerms, "PolicyAndTermsBilling");
